/** @jsxImportSource @emotion/react */

import { EuiFlexGroup, EuiFlexItem, EuiText } from "@inscopix/ideas-eui";

import { ToolEditorFormCodeConfigInstructions } from "./ToolEditorFormCodeConfigInstructions";
import { ToolEditorFormCodeUploadCodeBody } from "./ToolEditorFormCodeUploadBody";

export const ToolEditorFormCode = () => {
  return (
    <EuiFlexGroup
      direction="column"
      responsive={false}
      style={{ minHeight: 300 }}
    >
      <EuiFlexItem grow={false}>
        <EuiText size="s">
          <h2>Create and Upload your Custom Code</h2>
        </EuiText>
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <ToolEditorFormCodeConfigInstructions />
      </EuiFlexItem>
      <EuiFlexItem grow={false}>
        <ToolEditorFormCodeUploadCodeBody />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
